export default async function speak(text: string): Promise<void> {
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'sv-SE';
  const utteranceEnded = new Promise<void>((resolve) => {
    utterance.addEventListener('end', () => resolve());
    utterance.addEventListener('error', () => resolve());
  });
  window.speechSynthesis.speak(utterance);
  return utteranceEnded;
}
